import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteLoaderData,
  type LoaderFunctionArgs,
} from "react-router";
import { fetchSiteSettings } from "../src/marketing/site-settings";
import {
  isAdminPath,
  NO_INDEX_DIRECTIVE,
  publicSiteIsIndexable,
} from "../src/marketing/crawl-policy";
import {
  INCIDE_SCRIPT_SRC,
  INCIDE_SITE_ID,
  shouldLoadIncide,
} from "../src/incide";
import "../src/globals.css";

export async function loader({ request }: LoaderFunctionArgs) {
  const settings = await fetchSiteSettings(request);
  const id = settings?.faviconAssetId;
  const hostname = new URL(request.url).hostname;
  return {
    preventIndexing:
      !publicSiteIsIndexable() || isAdminPath(new URL(request.url).pathname),
    faviconHref:
      id && /^[a-zA-Z0-9_-]+$/.test(id) ? `/media/originals/${id}` : null,
    incideEnabled: shouldLoadIncide(process.env.ENVIRONMENT, hostname),
  };
}

export function Layout({ children }: { children: React.ReactNode }) {
  const data = useRouteLoaderData<typeof loader>("root");
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        {(data?.preventIndexing ?? true) && (
          <meta name="robots" content={NO_INDEX_DIRECTIVE} />
        )}
        {data?.faviconHref && <link rel="icon" href={data.faviconHref} />}
        <link rel="stylesheet" href="https://use.typekit.net/oqr3zlm.css" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin=""
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Nunito+Sans:wght@300;500;700;900&display=swap"
          rel="stylesheet"
        />
        {data?.incideEnabled && (
          <script src={INCIDE_SCRIPT_SRC} data-site={INCIDE_SITE_ID} defer />
        )}
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function Root() {
  return <Outlet />;
}

/** Default head title — marketing routes override it via marketingMeta. */
export function meta() {
  return [{ title: "Diality" }];
}
